import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=ddf49b2c&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=ts&"
export * from "./customer.vue?vue&type=script&lang=ts&"
import style0 from "./customer.vue?vue&type=style&index=0&id=ddf49b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf49b2c",
  null
  
)

export default component.exports